import { z } from "zod"

export enum HOME_CONTENT {
  CHRONO = "chrono",
  RIGHT_NOW = "right_now",
  WORKOUT = "workout",
  NEWS = "news",
}

export enum HOME_RIGHT_NOW_CONTENT {
  BENCHMARKS = "benchmarks",
  EVENTS = "events",
  NONE = "none",
}

const chronoSchema = z.object({
  _type: z.literal(HOME_CONTENT.CHRONO),
})

const rightNowSchema = z.object({
  _type: z.literal(HOME_CONTENT.RIGHT_NOW),
  description: z.string(),
  content: z.union([
    z.literal(HOME_RIGHT_NOW_CONTENT.BENCHMARKS),
    z.literal(HOME_RIGHT_NOW_CONTENT.EVENTS),
    z.literal(HOME_RIGHT_NOW_CONTENT.NONE),
  ]),
})

const workoutSchema = z.object({
  _type: z.literal(HOME_CONTENT.WORKOUT),
})

const newsSchema = z.object({
  _type: z.literal(HOME_CONTENT.NEWS),
})

export const homeContentDtoSchema = z
  .object({
    title: z.string(),
    content: z
      .array(z.union([chronoSchema, rightNowSchema, workoutSchema, newsSchema]))
      .max(Object.values(HOME_CONTENT).length),
  })
  .meta({ id: "homeContentDtoSchema" })

// inferred types:
export type HomeContentDto = z.infer<typeof homeContentDtoSchema>
